import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PouchService } from '../../services/pouch-service';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core'; // add this import

interface ImageModel {
  type: string;
  image: string;
}

@Component({
  selector: 'horizontal-scroll',
  templateUrl: './horizontal-scroll.html',
  styleUrls: ['horizontal-scroll.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HorizontalScrollComponent implements OnInit, OnChanges {
  @Input() linkLabel = 'link';
  @HostListener('window:resize', [])
  @Input()
  pages = [];
  @Input() type = '';
  @Input() background: string;
  @Input() text: string;
  @Input() hideNav = false;
  @Input() navIcon: ImageModel;
  @Input() distance = 500;
  @Input() scrollSpeed = 5000;
  @Output() clickedEventEmiiter = new EventEmitter<any>();
  @ViewChild('hScroll', { static: false }) scrollWrapper: ElementRef;
  private scrollTimeout: any;
  leftArrowHide = true;
  rightArrow = false;
  interval: any;
  itemsWrapperStyle = {};

  constructor(public db: PouchService, private router: Router) {}

  onResize(): void {
    this.checkScrollArrows();
  }

  listenToItemsScroll(): void {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.checkScrollArrows();
    }, 100);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.checkScrollArrows();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pages) {
      setTimeout(() => this.checkScrollArrows(), 100);
    }
  }

  updateItemsWrapperWidth(): void {
    if (this.hideNav) {
      this.itemsWrapperStyle = { width: '100%' };
      return;
    }

    if (!this.leftArrowHide && this.rightArrow) {
      this.itemsWrapperStyle = { width: 'calc(100% - 100px)' }; // both arrows visible
    } else if (!this.leftArrowHide || this.rightArrow) {
      this.itemsWrapperStyle = { width: 'calc(100% - 50px)' }; // one arrow visible
    } else {
      this.itemsWrapperStyle = { width: '100%' }; // no arrows
    }
  }

  checkScrollArrows(): void {
    const el = this.scrollWrapper?.nativeElement;
    if (el) {
      this.leftArrowHide = el.scrollLeft <= 0;
      this.rightArrow = el.scrollLeft + el.clientWidth < el.scrollWidth;
      this.updateItemsWrapperWidth(); // call here
    }
  }

  scrollLeft(): void {
    const el = this.scrollWrapper.nativeElement;
    const distance = el.scrollLeft - this.distance;
    this.scroll(distance);
  }

  left(): void {
    this.interval = setInterval(() => this.scrollLeft(), this.scrollSpeed);
  }

  scrollRight(): void {
    const el = this.scrollWrapper.nativeElement;
    const distance = el.scrollLeft + this.distance;
    this.scroll(distance);
  }

  right(): void {
    this.interval = setInterval(() => this.scrollRight(), this.scrollSpeed);
  }

  scroll(distance: number): void {
    const el = this.scrollWrapper.nativeElement;
    el.scrollTo({ behavior: 'smooth', left: distance });
    setTimeout(() => this.checkScrollArrows(), 500); // Delay to allow scroll
  }

  clear(): void {
    clearInterval(this.interval);
  }

  open(type: string, mode: string, title = ''): void {
    if (type === 'chat') {
      this.router.navigateByUrl('/ChatPage');
    } else if (type == 'action') {
      this.onLinkClicked(mode);
    } else {
      const currentUrl = this.router.url.split('?')[0];
      if (type === currentUrl) {
        this.router.navigate([type], {
          queryParams: { mode: mode, type: this.type, title: title, t: new Date().getTime() },
        });
      } else {
        this.router.navigateByUrl(type, { state: { mode: mode, type: this.type, title: title } });
      }
    }
  }

  onLinkClicked(item: any): void {
    this.clickedEventEmiiter.emit(item);
  }
}
